jQuery(document).ready(function ($) {
    const $panels = $('.choose-your-stay__people, .choose-your-stay__dates');

    function closePanel($panel) {
        if (!$panel.hasClass('is-open')) return;

        $panel.find('.choose-your-stay__dropdown').first().slideUp(300, function () {
            $panel.removeClass('is-open');
        });
    }

    $panels.find('.choose-your-stay__toggle').on('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        const $panel = $(this).closest('.choose-your-stay__people, .choose-your-stay__dates');
        const isOpen = $panel.hasClass('is-open');

        $panels.not($panel).each(function () {
            closePanel($(this));
        });

        if (isOpen) {
            closePanel($panel);
        } else {
            $panel.addClass('is-open');
            $panel.find('.choose-your-stay__dropdown').first().slideDown(300);
        }
    });

    $('.choose-your-stay__dropdown').on('click', function (event) {
        event.stopPropagation();
    });

    function updatePeopleLabel() {
        const adults = parseInt($('.js-choose-your-stay-adults').first().val(), 10) || 0;
        const children = parseInt($('.js-choose-your-stay-children').first().val(), 10) || 0;

        const adultsLabel = adults === 1 ? 'Adult' : 'Adults';
        const childrenLabel = children === 1 ? 'Child' : 'Children';

        $('.choose-your-stay__people-label').text(`${adults} ${adultsLabel} + ${children} ${childrenLabel}`);
    }

    function syncMewsDistributor() {
        const distributor = window.mewsDistributor;

        console.log(distributor);

        if (!distributor) return;

        const adults = parseInt($('.js-choose-your-stay-adults').first().val(), 10) || 1;
        const children = parseInt($('.js-choose-your-stay-children').first().val(), 10) || 0;
        const startDate = $('.js-choose-your-stay-date-from').first().datepicker('getDate');
        const endDate = $('.js-choose-your-stay-date-to').first().datepicker('getDate');

        distributor.setAdultCount(adults);
        distributor.setChildCount(children);

        if (startDate) distributor.setStartDate(startDate);
        if (endDate) distributor.setEndDate(endDate);
    }

    $(document).on('input change', '.js-choose-your-stay-adults, .js-choose-your-stay-children', function () {
        const $group = $(this).hasClass('js-choose-your-stay-adults')
            ? $('.js-choose-your-stay-adults')
            : $('.js-choose-your-stay-children');

        $group.not(this).val($(this).val());

        updatePeopleLabel();
        syncMewsDistributor();
    });

    $(document).on('mews:ready', syncMewsDistributor);

    updatePeopleLabel();

    $(document).on('click', function () {
        $panels.each(function () {
            closePanel($(this));
        });
    });

    function updateDatesLabel() {
        const from = $('.js-choose-your-stay-date-from').first().val() || 'DD/MM/YY';
        const to = $('.js-choose-your-stay-date-to').first().val() || 'DD/MM/YY';

        $('.choose-your-stay__dates-label').text(`${from} - ${to}`);
    }

    $('.choose-your-stay__datepicker').datepicker({
        dateFormat: 'dd/mm/yy',
        minDate: 0,
        onSelect: function (dateText, instance) {
            const $input = $(this);

            if ($input.hasClass('js-choose-your-stay-date-from')) {
                $('.js-choose-your-stay-date-from').not($input).val(dateText);
                $('.js-choose-your-stay-date-to').datepicker('option', 'minDate', dateText);
            } else {
                $('.js-choose-your-stay-date-to').not($input).val(dateText);
            }

            updateDatesLabel();
            syncMewsDistributor();
        }
    });

    function addDays(date, days) {
        const result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

    const defaultFrom = addDays(new Date(), 1);
    const defaultTo = addDays(defaultFrom, 7);

    $('.js-choose-your-stay-date-from').datepicker('setDate', defaultFrom);
    $('.js-choose-your-stay-date-to')
        .datepicker('option', 'minDate', defaultFrom)
        .datepicker('setDate', defaultTo);

    updateDatesLabel();
    syncMewsDistributor();

    const $lightbox = $('#choose-your-stay-lightbox');

    function openLightbox() {
        $lightbox.addClass('is-open').attr('aria-hidden', false);
        $('body').addClass('choose-your-stay-lightbox-open');
    }

    function closeLightbox() {
        $lightbox.removeClass('is-open').attr('aria-hidden', true);
        $('body').removeClass('choose-your-stay-lightbox-open');
    }

    $(document).on('click', '.js-choose-your-stay-lightbox-toggle', function (event) {
        event.preventDefault();
        openLightbox();
    });

    $(document).on('click', '.js-choose-your-stay-lightbox-close', function (event) {
        event.preventDefault();
        closeLightbox();
    });

    $(document).on('keydown', function (event) {
        if (event.key === 'Escape' && $lightbox.hasClass('is-open')) {
            closeLightbox();
        }
    });
});
